import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const ContentContext = createContext({ data: {}, overrides: {}, refresh: () => {} });

export const useSiteContent = () => useContext(ContentContext);

export const useContent = (section, fallback) => {
  const { data, overrides } = useContext(ContentContext);
  return { ...fallback, ...(data?.[section] || {}), ...(overrides?.[section] || {}) };
};

export const ContentProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const refresh = () => api.get('/content').then((r) => setData(r.data)).catch(() => setData({}));
  useEffect(() => { refresh(); }, []);
  return (
    <ContentContext.Provider value={{ data: data || {}, overrides: {}, refresh }}>
      {children}
    </ContentContext.Provider>
  );
};

export const ContentOverride = ({ overrides, children }) => {
  const ctx = useContext(ContentContext);
  return (
    <ContentContext.Provider value={{ ...ctx, overrides }}>
      {children}
    </ContentContext.Provider>
  );
};
